import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import legalContent from '../legal/legalContent.json';

/**
 * The one page on this site that names the companies behind the app - the
 * mirror of the app's Subprocessors screen, rendered from the same generated
 * data. The privacy policy names none of them and links here instead, so a
 * vendor that changes is edited once rather than in five paragraphs across
 * two products.
 */
const SubprocessorsPage = () => {
  const { processors, company, lastUpdated } = legalContent;

  return (
    <div className="terms-page">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="page-header">
            <Link to="/privacy-policy" className="back-link">
              <ArrowLeft size={20} />
              Back to Privacy Policy
            </Link>
            <h1>{processors.title}</h1>
            <p className="last-updated">Last updated: {lastUpdated}</p>
          </div>

          <div className="terms-content">
            <section className="terms-section">
              <p>{processors.intro}</p>
            </section>

            <section className="terms-section">
              <h2>{processors.listHeading}</h2>
              {processors.items.map((processor) => (
                <div className="subsection" key={processor.name}>
                  <h3>
                    {processor.name} - <span className="inline-link">{processor.region}</span>
                  </h3>
                  <p>{processor.purpose}</p>
                  <p>{processor.data}</p>
                  {processor.note ? <p>{processor.note}</p> : null}
                </div>
              ))}
            </section>

            <section className="terms-section">
              <p>{processors.outro}</p>
              <div className="contact-info">
                <p>
                  <strong>Privacy:</strong> {company.privacyEmail}
                </p>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SubprocessorsPage;
